export default "__VITE_ASSET__DiIv8MaA__"